import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_METADATA } from '../action-types'

const cleanupCommonFetchMetadata = createAction(COMMON_FETCH_METADATA.CLEANUP)

export default cleanupCommonFetchMetadata
